import { Component, Input } from '@angular/core';
import { RegisterDto } from '@assetaccountant/api/models/register.dto';
import { AuthenticationService } from '@assetaccountant/core';
import { RegisterRole } from '@assetaccountant/core/models/enum/register-role';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './register-access-modal.component.html',
  styleUrls: ['./register-access-modal.component.scss'],
  standalone: false,
})
export class RegisterAccessModalComponent {
  @Input() register: RegisterDto;

  constructor(
    public modal: NgbActiveModal,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private organisationService: OrganisationService,
  ) {}

  grantAccess() {
    const userId = this.authService.getCurrentLoggedOnUserId();

    this.organisationService
      .updateRegisterUser(userId, {
        registerId: this.register.id,
        registerRoleId: RegisterRole.Manager,
        isActive: true,
      })
      .subscribe(() => {
        this.toastr.success(`You can now access ${this.register.name}`);
        this.modal.close();
      });
  }
}
